import mock from '@/fake-db/mock.js'
import is from 'is_js'

const data = [
  {
    date: '2020-03-01',
    country: 'Ghana',
    region: 'Northern',
    town: 'Tamale',
    strain: 'China',
    position: {
      lat: 9.6666,
      lng: -2.6163
    }
  },
  {
    date: '2020-03-01',
    country: 'Ghana',
    region: 'Ashanti',
    town: 'Kumasi',
    strain: 'UK',
    position: {
      lat: 6.6666,
      lng: -1.6163
    }
  },
  {
    date: '2020-03-01',
    country: 'Ghana',
    region: 'Ashanti',
    town: 'Kumasi',
    strain: 'China',
    position: {
      lat: 6.6666,
      lng: -1.6163
    }
  },
  {
    date: '2020-03-02',
    country: 'Ghana',
    region: 'Ashanti',
    town: 'Kumasi',
    strain: 'RSA',
    position: {
      lat: 6.6666,
      lng: -1.6163
    }
  },
  {
    date: '2020-03-03',
    country: 'Ghana',
    region: 'Ashanti',
    town: 'Kumasi',
    strain: 'Other',
    position: {
      lat: 6.6666,
      lng: -1.6163
    }
  }
]

function betweenDates(dateFrom, dateTo, dateCheck) {
  let d1 = dateFrom.split('-')
  let d2 = dateTo.split('-')
  let c = dateCheck.split('-')

  let from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]) // -1 because months are from 0 to 11
  let to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0])
  let check = new Date(c[2], parseInt(c[1]) - 1, c[0])

  return check >= from && check <= to
}

function getDaysArray(start, end) {
  // eslint-disable-next-line no-var
  for (var arr = [], dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
    arr.push(new Date(dt))
  }
  return arr
}

mock.onPost('/api/heatmap').reply(request => {
  const { country, region, town, start, end } = JSON.parse(request.data)

  let error = 'Something went wrong'

  try {
    const seqs = data.filter(function(d) {
      let ccheck = country === 'All' || d.country === country
      let rcheck = region === 'All' || d.region === region
      let tcheck = town === 'All' || d.town === town
      let dcheck = betweenDates(start, end, d.date)
      return ccheck && rcheck && tcheck && dcheck
    })

    //console.log('Sequences')
    //console.log(seqs)

    let sdates = {}
    let heatmapData = []
    let strains = ['China', 'UK', 'RSA', 'Other']

    let daysArray = getDaysArray(start, end)

    for (let s in strains) {
      sdates[strains[s]] = []
      let data = []
      for (let d in daysArray) {
        let day = daysArray[d].toISOString().slice(0, 10)
        data.push({ x: day, y: 0 })
      }
      heatmapData.push({ name: strains[s], data: data })
    }

    for (let x in seqs) {
      let d = seqs[x]
      let hd = d.date

      // Heatmap tracking
      for (let i in strains) {
        let strain = strains[i]
        if (d.strain === strain) {
          if (is.not.undefined(sdates[strain][hd])) {
            sdates[strain][hd]++
          } else {
            sdates[strain][hd] = 1
          }
        }
      }
    }

    for (let s in strains) {
      let strain = strains[s]
      for (let x in sdates[strain]) {
        const y = sdates[strain][x]
        for (let u in heatmapData[s].data) {
          if (heatmapData[s].data[u].x === x) {
            heatmapData[s].data[u].y = y
          }
        }
      }
    }

    let reqData = { heatmap: heatmapData, strains: strains }

    return [200, reqData]
  } catch (e) {
    console.log(e)
    error = e
  }

  return [200, { error }]
})

mock.onPost('/api/bigpie').reply(request => {
  const { country, region, town, start, end } = JSON.parse(request.data)

  let error = 'Something went wrong'

  try {
    const seqs = data.filter(function(d) {
      let ccheck = country === 'All' || d.country === country
      let rcheck = region === 'All' || d.region === region
      let tcheck = town === 'All' || d.town === town
      let dcheck = betweenDates(start, end, d.date)
      return ccheck && rcheck && tcheck && dcheck
    })

    //console.log('Sequences')
    //console.log(seqs)

    let scount = {}
    let strains = ['China', 'UK', 'RSA', 'Other']

    for (let s in strains) {
      scount[strains[s]] = 0
    }

    for (let x in seqs) {
      scount[seqs[x].strain]++
    }

    let reqData = { series: [] }
    for (let s in strains) {
      reqData['series'].push(scount[strains[s]])
    }

    return [200, reqData]
  } catch (e) {
    console.log(e)
    error = e
  }

  return [200, { error }]
})

mock.onPost('/api/sequences').reply(request => {
  const { country, region, town, start, end } = JSON.parse(request.data)

  let error = 'Something went wrong'

  try {
    const seqs = data.filter(function(d) {
      let ccheck = country === 'All' || d.country === country
      let rcheck = region === 'All' || d.region === region
      let tcheck = town === 'All' || d.town === town
      let dcheck = betweenDates(start, end, d.date)
      return ccheck && rcheck && tcheck && dcheck
    })

    //console.log('Sequences')
    //console.log(seqs)

    let strains = ['China', 'UK', 'RSA', 'Other']
    let towns = []
    let seen = []
    for (let x in seqs) {
      let d = seqs[x]
      let idx = d.region + '-' + d.town

      if (is.inArray(idx, seen)) {
        for (let i in strains) {
          if (d.strain === strains[i]) {
            towns[idx].pie[i]++
          }
        }
      } else {
        let s = []
        for (let i in strains) {
          s[i] = 0
        }
        for (let i in strains) {
          if (d.strain === strains[i]) {
            ++s[i]
          }
        }
        towns[idx] = { region: d.region, town: d.town, position: d.position, pie: s }
        seen.push(idx)
      }
    }

    let reqData = { sequence: [], strains: strains }
    for (let x in towns) {
      let t = towns[x]
      let sum = 0
      for (let i in t.pie) {
        sum += t.pie[i]
      }
      for (let i in t.pie) {
        t.pie[i] = sum === 0 ? 0 : Math.round((t.pie[i] / sum) * 100, 2)
      }
      reqData['sequence'].push(t)
    }

    return [200, reqData]
  } catch (e) {
    console.log(e)
    error = e
  }

  return [200, { error }]
})
